<script setup>
import {useUser} from "../../store/user"
import {useSystem} from "../../store/system";
import {ref} from "vue";

const systemStore = useSystem()
const userStore = useUser()

//获取所有订单记录
userStore.orderListApi()


const dialogVisible = ref(false)

const showDetail = (id) => {
  userStore.orderDetailApi(id)
  setTimeout(() => {
    dialogVisible.value = true
  }, 300)
}


</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Order</div>
        <div class="tw-p-4">
          <el-table
              :data="userStore.getOrderList"
              class="tw-w-full"
          >
            <el-table-column prop="statrt_time" label="Start Time">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.statrt_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="end_time" label="End Time">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.end_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_num" label="Order No"/>
            <el-table-column prop="name" label="Name"/>
            <el-table-column prop="products_day" label="Period">
              <template #default="{row, column, $index}">
                <div>{{row.products_day}} Day</div>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="Number"/>
            <el-table-column prop="amount" label="Amount">
              <template #default="{row, column, $index}">
                <div>$ {{row.amount}}</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="daily_income" label="Daily Income">-->
<!--              <template #default="{row, column, $index}">-->
<!--                <div>$ {{row.daily_income}}</div>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="earnings" label="Earnings">-->
<!--              <template #default="{row, column, $index}">-->
<!--                <div>$ {{row.earnings}}</div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="status" label="Status">
              <template #default="{row, column, $index}">
                <!--              1：正常 2：暂停 3：结束-->
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-green-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 1">normal</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-orange-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 2">Processed</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-blue-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 3">Closed</div>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="action">
              <template #default="{row, column, $index}">
                <el-button color="#a034fa" @click="showDetail(row.id)"><el-icon :size="20"><List /></el-icon></el-button>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>

  <!--    dialog modal-->
  <el-dialog class="dialog-bg xs:!tw-w-[90vw] md:!tw-w-[800px]" v-model="dialogVisible" :show-close="false" title="Shipping address">
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass" class="xs:tw-ml-[2rem] md:tw-ml-[6rem] !tw-text-[24px] !tw-text-white tw-font-bold">Order Details</h4>
        <button class="modal__close" type="button" @click="dialogVisible = false"><i class="ti ti-square-x"></i></button>
      </div>
    </template>

    <div class="tw-py-2 xs:tw-px-[1.2rem] md:tw-px-[6rem] tw-pb-5 tw-text-white tw-text-[1.2rem] xs:!tw-text-[16px]">
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Order No</div>
        <div>{{userStore.getOrderDetail.order_num}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Name</div>
        <div>{{userStore.getOrderDetail.name}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Number</div>
        <div>{{userStore.getOrderDetail.number}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Amount</div>
        <div>$ {{userStore.getOrderDetail.amount}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Products Day</div>
        <div>{{userStore.getOrderDetail.products_day}} Day</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Daily Income</div>
        <div>$ {{userStore.getOrderDetail.daily_income}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Earnings</div>
        <div>$ {{userStore.getOrderDetail.earnings}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>Start Time</div>
        <div>{{systemStore.formatDate(userStore.getOrderDetail.statrt_time)}}</div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
        <div>End Time</div>
        <div>{{systemStore.formatDate(userStore.getOrderDetail.end_time)}}</div>
      </div>
    </div>

    <!-- design elements -->
    <span class="screw screw--big-tl"></span>
    <span class="screw screw--big-bl"></span>
    <span class="screw screw--big-br"></span>

  </el-dialog>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
